// extracted by mini-css-extract-plugin
export default {"countInIndicator":"style_countInIndicator__kOXhE","spin":"style_spin__TDNVf"};